import { FEATURES, handleAxiosError } from '../api';
import axios from '../axios';
import * as Types from '../types';
import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { AxiosError } from 'axios';

export const ATLAS_THEME_LS_KEY = 'atlas_theme_enabled';

export const fetchFeatures =
  () =>
  async (dispatch: Dispatch<AnyAction>): Promise<void> => {
    try {
      const {
        data: { data: payload },
      } = await axios.get(FEATURES);

      dispatch({
        type: Types.FeatureTypes.FETCH_ALL,
        payload,
      });

      // Persist atlas FF value so the theme variant is known on next page load
      // before the session fetch completes, preventing a flash of wrong theme.
      const isAtlasEnabled = (payload as Types.Feature[]).some(
        (f) => f.key === Types.FeatureFlag.ATLAS_THEME && f.enabled,
      );
      try {
        localStorage.setItem(ATLAS_THEME_LS_KEY, String(isAtlasEnabled));
      } catch {
        // localStorage unavailable (e.g. private browsing) — silent fallback
      }
    } catch (error) {
      handleAxiosError(error as AxiosError<{ errors: { message: string }[] }>);
    }
  };
